module.exports = __webpack_public_path__ + "static/media/slot-machine.7abe1257.webp";